import L from "leaflet"
import { useContext, useState } from "react"
import { Polyline } from "react-leaflet"
import useAsyncEffect from "use-async-effect"

import { MapContext, useAppSelector } from "@/App"
import { usePrevious } from "@/utils/hooks"
import { MapRoute } from "@/views/MapView"

const MAP_PADDING = 24
const LAYERS_TOGGLER_HEIGHT = 64
const ABOUT_ORDER_HEIGHT = 208

export const Routes = ({ routes }: { routes: MapRoute[] }) => {
  const orderId = useAppSelector((state) => state.ui.focusedOrderId)

  const [positions, setPositions] = useState<Array<L.LatLngExpression[]>>([])

  const prevOrderId = usePrevious(orderId)

  const mapRef = useContext(MapContext)

  useAsyncEffect(
    async (isSubscribed) => {
      try {
        const polylines = await fetchAllPolylines(routes)

        if (!isSubscribed()) return

        setPositions(() => {
          if (orderId && orderId !== prevOrderId) {
            const bounds = polylines.map((polyline) => L.polyline(polyline).getBounds())

            if (bounds.length && mapRef?.current) {
              mapRef.current.leafletElement.flyToBounds(bounds as unknown as L.LatLngBoundsExpression, {
                paddingTopLeft: [MAP_PADDING, MAP_PADDING * 2 + LAYERS_TOGGLER_HEIGHT],
                paddingBottomRight: [MAP_PADDING, MAP_PADDING * 2 + ABOUT_ORDER_HEIGHT],
                animate: false,
              })
            }
          }
          return polylines
        })
      } catch (error) {
        console.warn(error)
      }
      // Remove along with usePrevious hook for "tracking mode"
      // eslint-disable-next-line
    },
    [mapRef, routes, orderId]
  )

  return (
    <>
      {positions.map((position, index) => (
        <Polyline
          key={`${orderId}-${index}-${routes[index]?.color}`}
          positions={position}
          className={`route route--${routes[index]?.color}`}
        />
      ))}
    </>
  )
}

async function fetchPolyline(route: MapRoute) {
  const response = await fetch(
    `https://vrp.deligoo.pl/ors/v2/directions/driving-car?start=${route.from![1]},${route.from![0]}&end=${
      route.to![1]
    },${route.to![0]}`
  )

  if (!response.ok) throw response
  const data = await response.json()
  const polyline = data?.features[0]?.geometry?.coordinates?.map((item: L.LatLngExpression[]) => [
    item[1],
    item[0],
  ]) as L.LatLngExpression[]
  return polyline
}

function fetchAllPolylines(routes: MapRoute[]) {
  return Promise.all([...routes.map((route) => fetchPolyline(route))])
}
